import { log } from '@domgen/shared/src/utils/log';

const isAdobeAnalyticsAvailable = (): boolean =>
  typeof window !== 'undefined' && typeof window._satellite !== 'undefined';

/**
 * The Adobe Analytics signal for completed registration events. This function sends a tracking event to Adobe Analytics using the `_satellite.track` method.
 * For more information, see the following Jira ticket:
 * https://domgen.atlassian.net/browse/UEO-1044
 */
export const adobeTrackRegistration = (data: Omit<AdobeRegistrationData, 'ctx'>) => {
  if (isAdobeAnalyticsAvailable()) {
    log.info({
      message: 'Tracking registration event with Adobe Analytics',
      data,
    });
    window._satellite.track('productRegistration', { ...data, ctx: 'registrationComplete' });
  } else {
    // Optionally, you can log a warning if Adobe Analytics is not available
    log.warn({
      message: 'Adobe Analytics is not available. Registration event not tracked.',
      data,
    });
  }
};

/**
 * The Adobe Analytics signal for completed purchase events. This function sends a tracking event to Adobe Analytics using the `_satellite.track` method.
 * For more information, see the following Jira ticket:
 * https://domgen.atlassian.net/browse/UEO-1044
 */
export const adobeTrackPurchaseCompletion = (data: Omit<AdobePurchaseCompleteData, 'ctx'>) => {
  if (isAdobeAnalyticsAvailable()) {
    log.info({
      message: 'Tracking purchase completion event with Adobe Analytics',
      data,
    });
    window._satellite.track('productRegistration', { ...data, ctx: 'purchaseComplete' });
  } else {
    // Optionally, you can log a warning if Adobe Analytics is not available
    log.warn({
      message: 'Adobe Analytics is not available. Purchase completion event not tracked.',
      data,
    });
  }
};
